'use client'

import { DocumentResponse } from '@backend/schemas'
import { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

import DataTable from '../data-table'
import { useDocumentsTableColumns, renderExpandedRow } from './columns'

type Props = {
  documents: DocumentResponse[]
} & Partial<ComponentProps<typeof DataTable>>

const DocumentsTable = ({ documents, ...props }: Props) => {
  const columns = useDocumentsTableColumns(documents)
  const { t } = useTranslation()

  return (
    <DataTable
      showSearchFilter
      {...props}
      canRenderExpandedRow={data => data.status === 'done'}
      columns={columns}
      data={documents}
      getRowProps={data => ({
        className: cn({
          'bg-gradient-to-r from-error/10 dark:from-error/20 to-error/0': data.status === 'error',
          'bg-gradient-to-r from-info/10 dark:from-info/20 to-info/0':
            data.status !== 'done' && data.status !== 'error',
        }),
      })}
      renderExpandedRow={data => renderExpandedRow(data, t)}
    />
  )
}

export default DocumentsTable
